/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M3.772 10.165a8.974 8.974 0 0 1 8.77-7.125 8.958 8.958 0 1 1 0 17.917.833.833 0 0 1 0-1.667 7.292 7.292 0 1 0-7.032-9.222.207.207 0 0 0 .2.264h1.457a.417.417 0 0 1 .299.711L4.839 13.67a.417.417 0 0 1-.59 0l-2.627-2.626a.417.417 0 0 1 .295-.711h1.652c.099 0 .184-.07.203-.167Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13.187 11.555 3.33 3.054a.719.719 0 0 1 .045 1.014.726.726 0 0 1-1.016.044l-3.563-3.266a.719.719 0 0 1-.233-.53V7.919a.719.719 0 1 1 1.437 0v3.636Z"
})), "0 0 24 24", "History");